<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  count: { type: Number, default: 0 },
});

const emit = defineEmits(['align']);

const { t } = useI18n();

const ACTIONS = [
  { id: 'left', icon: 'i-lucide-align-start-vertical' },
  { id: 'top', icon: 'i-lucide-align-start-horizontal' },
  { id: 'middle', icon: 'i-lucide-align-center-horizontal' },
  { id: 'distributeX', icon: 'i-lucide-align-horizontal-distribute-center' },
  { id: 'distributeY', icon: 'i-lucide-align-vertical-distribute-center' },
];
</script>

<template>
  <div
    class="absolute z-20 flex items-center gap-1 p-1 -translate-x-1/2 border shadow-sm rounded-xl bottom-16 start-1/2 border-n-weak bg-n-solid-1"
  >
    <span class="px-2 text-xs font-medium text-n-slate-11">
      {{ t('AGENT_BOTS.VISUAL_BUILDER.ALIGN.SELECTED', { count }) }}
    </span>
    <Button
      v-for="action in ACTIONS"
      :key="action.id"
      size="sm"
      variant="ghost"
      color="slate"
      :icon="action.icon"
      is-icon-only
      :disabled="count < 3 && action.id.startsWith('distribute')"
      :title="t(`AGENT_BOTS.VISUAL_BUILDER.ALIGN.${action.id.toUpperCase()}`)"
      @click="emit('align', action.id)"
    />
  </div>
</template>
